import ParentService from '../services/ParentService';
import router from '@/router';

const uuidv4 = require('uuid/v4');

const getDefaultState = () => ({
  parent: {
    id: null,
    uuid: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    mobile_1: '',
    mobile_2: '',
    email: '',
    country: '',
    region: '',
    district: '',
    village: '',
    address: '',
    sex: '',
  },
  parents: [],
  studentParents: [],
  schoolParents: [],
});

const parents = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    first_name(state, val) {
      state.parent.first_name = val;
    },
    middle_name(state, val) {
      state.parent.middle_name = val;
    },
    last_name(state, val) {
      state.parent.last_name = val;
    },
    mobile_1(state, val) {
      state.parent.mobile_1 = val;
    },
    mobile_2(state, val) {
      state.parent.mobile_2 = val;
    },
    email(state, val) {
      state.parent.email = val;
    },
    country(state, val) {
      state.parent.country = val;
    },
    region(state, val) {
      state.parent.region = val;
    },
    district(state, val) {
      state.parent.district = val;
    },
    village(state, val) {
      state.parent.village = val;
    },
    address(state, val) {
      state.parent.address = val;
    },
    sex(state, val) {
      state.parent.sex = val;
    },
    parent(state, val) {
      state.parent = val;
    },
    parents(state, val) {
      state.parents = val;
    },
    studentParents(state, val) {
      state.studentParents = val;
    },
    schoolParents(state, val) {
      state.schoolParents = val;
    },
    resetParents(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async CREATE_PARENT({ state }) {
      state.parent.uuid = uuidv4();
      await ParentService.addParent(state.parent);
    },
    async UPDATE_PARENT({ state }) {
      await ParentService.updateParent(state.parent);
    },
    async GET_PARENTS(context) {
      const res = await ParentService.fetchParents();
      const data = res.data.results;
      context.commit('parents', data);
    },
    async GET_PARENTS_BY_TEACHER(context) {
      const res = await ParentService.getParentsByTeacher({
        teacherId: context.rootState.workshops.workshop.teacher,
      });
      const data = res.data.results;
      context.commit('parents', data);
    },
    async GET_PARENTS_BY_STUDENT(context) {
      const res = await ParentService.getStudentParents({
        id: router.currentRoute.params.id,
      });
      const data = res.data.results;
      context.commit('studentParents', data);
    },
    async GET_SCHOOL_PARENTS(context) {
      const res = await ParentService.getSchoolParents({
        studentId: router.currentRoute.params.id,
      });
      const data = res.data.results;
      context.commit('schoolParents', data);
    },
    async RESET_PARENTS_STATE(context) {
      await context.commit('resetParents');
    },
  },
  getters: {
    getParentStudents: state => state.parent.students,
    getStudentParents: state => state.studentParents,
    getSchoolParents: state => state.schoolParents,
  },
};

export default parents;
